import _ from 'lodash';
import { DistributionType, EmailTemplatePropertiesUnderValidation, IEmailTemplate, IValidationErrorCollection } from '../../../models';
import * as AudienceValidation from '../AudienceValidation';

export const validateInvitationEmail = (
	invitationEmail: IEmailTemplate,
	distributionType?: DistributionType,
	invitationEmailValidationErrors?: IValidationErrorCollection,
	fieldNames?: EmailTemplatePropertiesUnderValidation[],
) => {
	let inviteEmailValidationErrors = AudienceValidation.validEmailTemplateFields(
		fieldNames || [
			EmailTemplatePropertiesUnderValidation.From,
			EmailTemplatePropertiesUnderValidation.ReplyToEmail,
			EmailTemplatePropertiesUnderValidation.Subject,
			EmailTemplatePropertiesUnderValidation.Content,
			EmailTemplatePropertiesUnderValidation.SurveyLink,
		],
		invitationEmail,
		distributionType,
	);

	// Remove survey link validation error
	if (
		fieldNames &&
		fieldNames.length === 1 &&
		fieldNames[0] === EmailTemplatePropertiesUnderValidation.SurveyLink &&
		invitationEmailValidationErrors
	) {
		inviteEmailValidationErrors = _.omit(invitationEmailValidationErrors, [
			EmailTemplatePropertiesUnderValidation.Content,
			EmailTemplatePropertiesUnderValidation.SurveyLink,
		]);
	}
	return inviteEmailValidationErrors;
};
